export default __webpack_public_path__ + "static/media/shem.28b7dd98.jpg";